import { Route, Routes } from 'react-router-dom'

import Copywriting from './screens/Copywriting'
import Details from './screens/Details'
import Media from './screens/Media'

const CampaignEditRoutes = () => (
  <Routes>
    <Route index element={<Details />} />
    <Route path="/media" element={<Media />} />
    <Route path="/copywriting" element={<Copywriting />} />
  </Routes>
)

export default CampaignEditRoutes
